var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcViewStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7V5.5C22 4.30653 21.5259 3.16193 20.682 2.31802C19.8381 1.47411 18.6935 1 17.5 1H5.5C4.30653 1 3.16193 1.47411 2.31802 2.31802C1.47411 3.16193 1 4.30653 1 5.5V23.5C1 24.6935 1.47411 25.8381 2.31802 26.682C3.16193 27.5259 4.30653 28 5.5 28H11.5",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H16",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.75H11.5",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.25H11.5",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5V29.5C16 30.2956 16.3161 31.0587 16.8787 31.6213C17.4413 32.1839 18.2044 32.5 19 32.5H28C28.7956 32.5 29.5587 32.1839 30.1213 31.6213C30.6839 31.0587 31 30.2956 31 29.5V14.5C31 13.7044 30.6839 12.9413 30.1213 12.3787C29.5587 11.8161 28.7956 11.5 28 11.5H19C18.2044 11.5 17.4413 11.8161 16.8787 12.3787C16.3161 12.9413 16 13.7044 16 14.5Z",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 28.75H25.75",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1158 17.802H25.2118C25.1244 17.4926 24.9937 17.197 24.8238 16.924H26.1778C26.2716 16.9244 26.3646 16.9068 26.4518 16.872C26.5377 16.8379 26.6159 16.7869 26.6818 16.722C26.7463 16.6585 26.7967 16.5822 26.8298 16.498C26.8626 16.4151 26.8771 16.326 26.8723 16.2369C26.8675 16.1479 26.8434 16.0609 26.8018 15.982C26.7585 15.9044 26.7 15.8364 26.6298 15.782C26.5569 15.7241 26.4733 15.6813 26.3838 15.656C26.2935 15.6302 26.1991 15.622 26.1058 15.632H20.8238C20.6415 15.6337 20.4669 15.7053 20.3358 15.832C20.2723 15.8904 20.2217 15.9614 20.187 16.0404C20.1524 16.1194 20.1345 16.2047 20.1345 16.291C20.1345 16.3773 20.1524 16.4626 20.187 16.5416C20.2217 16.6206 20.2723 16.6916 20.3358 16.75C20.4669 16.8767 20.6415 16.9483 20.8238 16.95H22.3418C22.64 16.9556 22.9313 17.0405 23.1858 17.196C23.4342 17.3467 23.6352 17.5644 23.7658 17.824H20.8138C20.6315 17.8257 20.4569 17.8973 20.3258 18.024C20.2623 18.0824 20.2117 18.1534 20.177 18.2324C20.1424 18.3114 20.1245 18.3967 20.1245 18.483C20.1245 18.5693 20.1424 18.6546 20.177 18.7336C20.2117 18.8126 20.2623 18.8836 20.3258 18.942C20.4569 19.0687 20.6315 19.1403 20.8138 19.142H23.7598C23.6761 19.2956 23.5732 19.4381 23.4538 19.566C23.3061 19.7082 23.1322 19.8202 22.9418 19.896C22.7509 19.9723 22.5474 20.0123 22.3418 20.014H20.8098C20.6352 20.0106 20.4658 20.0735 20.3358 20.19C20.2398 20.277 20.1734 20.3918 20.1458 20.5183C20.1181 20.6449 20.1307 20.7769 20.1818 20.896C20.219 20.9809 20.2743 21.0566 20.3438 21.118L24.1318 24.49C24.263 24.603 24.4306 24.6648 24.6038 24.664C24.6995 24.6656 24.7946 24.6486 24.8838 24.614C24.9716 24.5802 25.0519 24.5292 25.1198 24.464C25.1799 24.4036 25.2271 24.3316 25.2585 24.2523C25.2898 24.173 25.3046 24.0882 25.302 24.003C25.2994 23.9178 25.2794 23.834 25.2432 23.7568C25.2071 23.6796 25.1555 23.6106 25.0918 23.554L22.5398 21.288C23.1629 21.2465 23.7587 21.0163 24.2478 20.628C24.7229 20.2523 25.0627 19.732 25.2158 19.146H26.1198C26.3021 19.1445 26.4768 19.0728 26.6078 18.946C26.6712 18.8876 26.7219 18.8166 26.7565 18.7376C26.7912 18.6586 26.8091 18.5733 26.8091 18.487C26.8091 18.4007 26.7912 18.3154 26.7565 18.2364C26.7219 18.1574 26.6712 18.0864 26.6078 18.028C26.4768 17.9011 26.3021 17.8295 26.1198 17.828L26.1158 17.802Z",
    fill: "#2C4C8F",
    stroke: "#2C4C8F",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewStatement);
export default __webpack_public_path__ + "static/media/ic_view_statement.65adad719af76ec4921fc5fb0bbfaf2d.svg";
export { ForwardRef as ReactComponent };